import template from './ConfirmationModalView.html';
import controller from './ConfirmationModalController';
export default (params) => {
    return {
        template,
        controller,
        controllerAs: '$ctrl',
        ...params,
        inputs: {
            ...params.inputs,
            title: params.title || { text: '' },
            body: params.body || '',
            buttons: params.buttons || {},
            modalClass: params.modalClass || '',
            modalSizeClass: params.modalSizeClass || '',
            bodyClass: params.bodyClass || '',
            bodyContentClass: params.bodyContentClass || '',
            footerClass: params.footerClass || '',
            footerContentClass: params.footerContentClass || '',
            size: params.size || 'sm',
            theme: params.theme || '',
        },
    };
};
